import { SVG, SVGProps } from './svg'

export function IconToolPosition(props: SVGProps) {
  return (
    <SVG {...props} viewBox="0 0 32 32">
      <path
        fillRule="evenodd"
        d="M5 7.5c-.3 0-.5.2-.5.5v.8a.5.5 0 001 0v-.3h.6a.5.5 0 000-1H5zM9.4 7.5a.5.5 0 000 1h2.2a.5.5 0 000-1H9.4zM14.9 7.5a.5.5 0 000 1h2.2a.5.5 0 000-1h-2.2zM20.4 7.5a.5.5 0 000 1h2.2a.5.5 0 000-1h-2.2zM25.9 7.5a.5.5 0 000 1h.6v.3a.5.5 0 001 0V8c0-.3-.2-.5-.5-.5h-1.1zM27.5 11.2a.5.5 0 00-1 0v1.6a.5.5 0 001 0v-1.6zM5.5 11.2a.5.5 0 00-1 0v1.6a.5.5 0 001 0v-1.6zM27.5 15.2a.5.5 0 00-1 0v.3h-21v-.3a.5.5 0 00-1 0V24c0 .3.2.5.5.5h22c.3 0 .5-.2.5-.5v-8.8zm-1 1.3h-21v7h21v-7z"
      />
    </SVG>
  )
}
